// extracted by mini-css-extract-plugin
module.exports = {"addColumnBlock":"AddColumn_addColumnBlock__2XCYB","form":"AddColumn_form__33U8g","bottomButton":"AddColumn_bottomButton__2-RwO"};